export const speechbubbleSelector = (state) => state.speechbubble;
